import Icon from '@cobliteam/ui/icons';
import { Shimmer } from './Shimmer';

const Submitting = () => {
  return (
    <div className='mt-2 flex w-full items-center gap-1 px-3'>
      <Icon name='loader-circle' size='sm' color='gray-dark' className='animate-spin' aria-hidden='true' />
      <Shimmer duration={1} className='text-sm'>
        Enviando...
      </Shimmer>
    </div>
  );
};

export default Submitting;
